<script>
export default {
  name: 'SuspendMenu',
  data() {
    return {
      isMenuOpen: false,
    };
  },
  mounted() {
    document.addEventListener('mousedown', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    handleClickOutside(event) {
      if (
        this.$refs.menuWrapper &&
        !this.$refs.menuWrapper.contains(event.target)
      ) {
        this.isMenuOpen = false;
      }
    },
  },
};
</script>

<template>
  <div ref="menuWrapper" class="relative">
    <button
      type="button"
      class="flex items-center justify-center p-2 rounded-lg text-slate-600 dark:text-slate-300 hover:text-slate-900 dark:hover:text-white hover:bg-slate-100 dark:hover:bg-slate-700 transition-all duration-200"
      @click="toggleMenu"
    >
      <fluent-icon icon="more-vertical" size="20" />
    </button>

    <transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="opacity-0 scale-95 translate-y-[-8px]"
      enter-to-class="opacity-100 scale-100 translate-y-0"
      leave-active-class="transition ease-in duration-150"
      leave-from-class="opacity-100 scale-100 translate-y-0"
      leave-to-class="opacity-0 scale-95 translate-y-[-8px]"
    >
      <div
        v-if="isMenuOpen"
        class="absolute right-0 mt-2 min-w-[200px] origin-top-right rounded-xl shadow-xl bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 z-[9999] py-1 overflow-hidden"
        @mousedown.stop
        @click="isMenuOpen = false"
      >
        <slot />
      </div>
    </transition>
  </div>
</template>
